import { render, staticRenderFns } from "./editProducts.vue?vue&type=template&id=736f3944&"
import script from "./editProducts.vue?vue&type=script&lang=js&"
export * from "./editProducts.vue?vue&type=script&lang=js&"
import style0 from "./editProducts.vue?vue&type=style&index=0&id=736f3944&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports